import React from "react";
import styles from "../../_css/SessionActions.module.css";
import { CustomButton, CustomButtonLight } from "../UI/CustomButtons";
import { X } from "lucide-react";
import { notifySuccess } from "../../utils/helper";

const SessionActions = ({
  show,
  onHide,
  generateSummary,
  saveSession,
  summary = false,
  saveDraft,
  publishSession,
}) => {
  const handleGenerateSummary = () => {
    generateSummary();
  };
  const handleSaveSession = () => {
    saveSession();
  };
  const handleSaveDraft = () => {
    saveDraft();
  };
  const handlePublishSession = () => {
    publishSession();
  };

  if (!show) return null;

  return (
    <div className={styles.customModalOverlay}>
      <div className={styles.customModal}>
        <div className={styles.customModalHeader}>
          <h5 className={styles.title}>Session Actions</h5>
          <button className={styles.closeButton} onClick={onHide}>
            <X size={20} />
          </button>
        </div>
        <div className={styles.customModalBody}>
          <div>
            <i>
              <img
                width={40}
                src={`${process.env.REACT_APP_PROJECT_URL}/img/file-icon.png`}
                alt="delete"
              />
            </i>
            <h5 className={styles.actionTitle}>Save Training Session</h5>
          </div>
          <div className={styles.modeRow}>
            {!summary ? (
              <div className={styles.modeButtons}>
                <CustomButtonLight
                  onClick={handleGenerateSummary}
                  text="Generate Summary"
                  width="48%"
                  icon="text"
                />
                <CustomButtonLight
                  onClick={handleSaveSession}
                  text="Save Session"
                  width="48%"
                  icon="voice"
                  // disabled={true}
                />
              </div>
            ) : (
              <div className={styles.modeButtons}>
                <CustomButtonLight
                  onClick={handleSaveDraft}
                  text="Save as Draft"
                  width="48%"
                />
                <CustomButton
                  onClick={handlePublishSession}
                  text="Publish Session"
                  width="48%"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionActions;
